import { getService } from '@/store/modules/apps/getters';
import { getPlacement } from '@/store/modules/placements/getters';
import { getPlacementVersion } from '@/store/modules/placements/modules/versions/getters';
import { element } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	computed: {
		...mapGettersShorthand({ element, getPlacement, getPlacementVersion, getService }),
		placement() {
			return this.getPlacement(this.element.placement);
		},
		placementVersion() {
			return this.getPlacementVersion(this.element.placement, this.element.version);
		},
		service() {
			return this.getService(this.placement.service);
		},
	},
};
